import {
  Component, Input, Output, EventEmitter, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';

import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';
import { SearchInputComponent } from 'shared/search/search-input/search-input.component';
import { FitmentsAdvancedSearchComponent } from 'shared/fitments/fitments-advanced-search/fitments-advanced-search.component';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'my-fitments-search',
  templateUrl: 'my-fitments-search.component.html',
  styleUrls: ['my-fitments-search.component.scss'],
})
export class MyFitmentsSearchComponent {

  showAdvancedSearch: boolean = false;

  @Input() filters: Array<ActiveFilterModel>;
  @Input() searchService: any;
  @Input() hasAdvancedSearch: boolean = false;
  @Input() ghostValue: string;
  @Input() searchModel: { filters: any } | void;
  @Input() searchResultsColumns: any;
  @Input() typeaheadSearchDataSource: any;

  @Output() advancedSearchRun: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchCancel: EventEmitter<any> = new EventEmitter();
  @Output() searchValueChanged: EventEmitter<any> = new EventEmitter();
  @Output() clearSearchClick: EventEmitter<any> = new EventEmitter();
  @Output() filterRemove: EventEmitter<any> = new EventEmitter();
  @Output() typeAheadSearchSelect: EventEmitter<any> = new EventEmitter();

  @ViewChild(SearchInputComponent, {static: false})
  searchInput: SearchInputComponent | void;

  @ViewChild(FitmentsAdvancedSearchComponent, {static: false})
  advancedSearch: FitmentsAdvancedSearchComponent | void;

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get searchModelFilters(): Array<ActiveFilterModel> {
    return this.searchModel && this.searchModel.filters || [];
  }

  get searchInputValue(): string {
    return this.searchInput && this.searchInput.searchTermValue;
  }

  get typeAheadValue(): any {
    return _.get(this.searchInput, 'typeAheadValue');
  }

  public resetSearchValue(value: string) {
    if (this.searchInput) {
      this.searchInput.resetValue(value);
    }
  }

  /*******************************************
   * COMPONENT EVENT HANDLERS
   *******************************************/

  onAdvancedSearchClick() {
    this.showAdvancedSearch = !this.showAdvancedSearch;
  }

  onAdvancedSearchRun() {
    this.advancedSearchRun.emit();
  }

  onAdvancedSearchCancel() {
    this.advancedSearchCancel.emit();
  }

  onSearchValueChanged(event: any) {
    this.searchValueChanged.emit(event);
  }

  onClearSearchClick() {
    this.clearSearchClick.emit();
  }

  onFilterRemove(event: any) {
    this.filterRemove.emit(event);
  }

  onTypeAheadSearchSelect(event: any) {
    this.typeAheadSearchSelect.emit(event);
  }
}
